import React from 'react'
import { Typography } from '@material-ui/core'
import Popup from '../Popup'
import Slide from '@material-ui/core/Slide'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useTheme } from '@material-ui/core/styles'

const MAILTO = 'mailto:support@gettingfocused.com?subject=Private Beta'

function SlideTransition(props) {
  return <Slide {...props} direction='up' />
}

export default ({ open, onClose = () => window.open(MAILTO) }) => {
  const theme = useTheme()

  const xs = useMediaQuery(theme.breakpoints.down('xs'), {
    noSsr: true
  })

  return (
    <Popup
      position='top'
      open={open}
      variant='info'
      message={
        <Typography variant={xs ? 'body2' : 'body1'}>
          <em>
            <b>Getting Focused App is in Beta</b>
          </em>
          <br />
          <br />
          This gives users the opportunity to test, and provide input and
          feedback on our application and its features.
          <br />
          <br />
          Please contact us for more information or to provide feedback:{' '}
          <a href={MAILTO} target='_blank' rel='noopener noreferrer'>
            support@gettingfocused.com
          </a>
        </Typography>
      }
      onCancel={onClose}
      onClose={onClose}
      onClick={onClose}
      preventCancel={false}
      keepOpen={true}
      transitionComponent={SlideTransition}
    />
  )
}
